<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-indent:0em; padding-top:150px;">Unless otherwise noted, Bible references are taken from New International Version (NIV) Copyright © 1978 by Biblica, Inc.</p>
<br/>
<p style="text-indent:0em;">Other Bibles referenced in this text include:</p>
<br/>
<p style="text-indent:0em;">New Living Translation – Copyright © 1996 by Tyndale House Foundation.</p>
<br/>
<p style="text-indent:0em;">Good News Translation – Copyright © 1976 by the American Bible Society</p>
<br/>
<p style="text-indent:0em;">New King James Version – Copyright © 1982 by Thomas Nelson</p>
<br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?e1b65af6